import { Config } from './../classes/config';
import { getConfig } from './../classes/getConfig/getConfig';
import { DataService } from './../services/data.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info',
  templateUrl: './info.page.html',
  styleUrls: ['./info.page.scss'],
})
export class InfoPage implements OnInit {
  constructor(private router: Router, private data: DataService) {
    const config: Config = getConfig();
    if (config.infoKunde === '' || config.infoPwd === '') {
      this.router.navigateByUrl('/home');
    } else {
      data.constructed.then(() => {
        this.data.login(false)
        .then((res) => {
          this.router.navigateByUrl('/home');
        })
        .catch(() => {
          this.data.username = config.infoKunde;
          this.data.password = config.infoPwd;
          this.data.save = true;
          this.data.login(false)
          .then((res) => {
            this.router.navigateByUrl('/home');
          })
          .catch(() => {
            this.router.navigateByUrl('/login');
          });
        });
      });
    }
  }

  ngOnInit() {
  }
}
